import { Component, Input } from '@angular/core';

@Component({
  selector: 'customer-comment-badge',
  templateUrl: './customer-comment-badge.component.html',
  standalone: false,
})
export class CustomerCommentBadge {
  @Input() hasCustomerCommentAlert: boolean;
  @Input() small: boolean;
}
